import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { usePortalRoot, useShadowRoot } from "../context/VNInvestChartsContext";
import { useWidgetI18n } from "../context/WidgetI18nContext";
export function DowngradeBanner({ open, upgradeUrl, onDismiss, onUpgrade, portalRoot: portalRootProp }) {
    const { t } = useWidgetI18n();
    const contextPortalRoot = usePortalRoot();
    const shadowRoot = useShadowRoot();
    const resolvedPortalRoot = portalRootProp ?? contextPortalRoot;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (open) {
            setVisible(true);
        }
        else {
            const timer = setTimeout(() => setVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [open]);
    if (!visible)
        return null;
    const banner = (_jsxs("div", { style: {
            position: "fixed",
            bottom: 24,
            left: "50%",
            transform: open ? "translateX(-50%)" : "translateX(-50%) translateY(20px)",
            opacity: open ? 1 : 0,
            transition: "opacity 0.3s, transform 0.3s",
            zIndex: 2147483000,
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "10px 20px",
            borderRadius: 10,
            background: "var(--vni-bg-warning, #7c3aed)",
            color: "#fff",
            fontSize: 13,
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            pointerEvents: "auto",
        }, role: "alert", children: [_jsxs("span", { children: [t("tier.downgrade.message"), " ", upgradeUrl && (_jsx("a", { href: upgradeUrl, target: "_blank", rel: "noopener noreferrer", style: { color: "#fcd34d", fontWeight: 600, textDecoration: "underline", cursor: "pointer" }, onClick: onUpgrade, children: t("tool.premiumLocked") }))] }), _jsx("button", { onClick: onDismiss, "aria-label": t("alert.dismiss"), style: {
                    background: "rgba(255,255,255,0.15)",
                    border: "none",
                    borderRadius: 6,
                    color: "#fff",
                    padding: "4px 10px",
                    fontSize: 12,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                }, children: t("alert.dismiss") })] }));
    if (typeof document === "undefined")
        return null;
    const target = resolvedPortalRoot ?? shadowRoot ?? document.body;
    return createPortal(banner, target);
}
